import AbstractChannel from './AbstractChannel'

export default class ParkRoll extends AbstractChannel {

  name = 'parkroll'
  title = 'ParkRoll'
  titleShort = 'ParkRoll'
  color = '#9466be'

  supportedFeatures = ['blackouts']

}
